/*
  KAYURI - Cajón de filtros y ordenación (portado a Dwell 4.3)
  - Desktop y móvil: tocar una opción NO aplica el filtro; se aplica al pulsar
    "Ver artículos" (o al enviar el formulario).
  - Mientras tanto actualiza la URL (replaceState) y el contador del botón en
    segundo plano, sin recargar.
  - "Ordenar por" (snippets/kayuri-drawer-sort.liquid) tampoco aplica hasta pulsar.
  - Al aplicar usa el render por secciones nativo (facets-form-component →
    updateFiltersByURL) y cierra el cajón (theme-drawer → close()).
*/
(function () {
  if (window.__kayuriFiltersDrawer43) return;
  window.__kayuriFiltersDrawer43 = true;

  var FILTER_STATE_KEY = 'kayuri_filters_drawer_state_v8';
  var PENDING_SORT_KEY = 'kayuri_pending_sort_by';
  var PREVIEW_COUNT_DELAY = 180;

  var previewCountTimer = null;
  var previewCountController = null;
  var previewCountRequestId = 0;
  var isRestoring = false;

  function cleanText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getDrawer() {
    return document.getElementById('filters-drawer');
  }

  function getDialog() {
    return document.querySelector('#filters-drawer dialog');
  }

  function getDrawerForm() {
    return document.querySelector('#filters-drawer form');
  }

  function getFacetsFormComponent() {
    return document.querySelector('#filters-drawer facets-form-component');
  }

  function getSectionId() {
    var component = getFacetsFormComponent();
    return (component && component.getAttribute('section-id')) || '';
  }

  function isDrawerOpen() {
    var dialog = getDialog();
    return !!(dialog && dialog.open);
  }

  function isInsideDrawer(target) {
    return !!(target && target.closest && target.closest('#filters-drawer'));
  }

  function isPriceFilter(details) {
    if (!details) return false;
    var summary = details.querySelector('summary');
    var summaryText = cleanText(summary && summary.textContent);
    var hasPriceInput = details.querySelector('input[name*="price"]');

    return !!hasPriceInput || summaryText.indexOf('precio') !== -1 || summaryText.indexOf('price') !== -1;
  }

  function detailsKey(details) {
    if (!details) return '';
    if (details.classList.contains('kayuri-drawer-sort')) return 'sort';
    if (isPriceFilter(details)) return 'price';

    var input = details.querySelector('input[name*="filter."], select[name*="filter."]');
    if (input && input.name) return 'input-name:' + input.name;

    var summary = details.querySelector('summary');
    var summaryText = cleanText(summary && summary.textContent);
    return summaryText ? 'summary:' + summaryText : '';
  }

  function uniqueKeys(keys) {
    return keys.filter(function (key, index) {
      return key && keys.indexOf(key) === index;
    });
  }

  function getOpenKeysFromDOM() {
    var drawer = getDrawer();
    if (!drawer) return [];
    return uniqueKeys(Array.prototype.map.call(drawer.querySelectorAll('details[open]'), detailsKey));
  }

  function readFilterState() {
    try {
      return JSON.parse(sessionStorage.getItem(FILTER_STATE_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function writeFilterState(openKeys) {
    try {
      sessionStorage.setItem(
        FILTER_STATE_KEY,
        JSON.stringify({ keepOpen: true, openKeys: uniqueKeys(openKeys), scrollY: window.scrollY })
      );
    } catch (error) {}
  }

  function clearFilterState() {
    try {
      sessionStorage.removeItem(FILTER_STATE_KEY);
    } catch (error) {}
  }

  function syncFilterStateFromDOM() {
    writeFilterState(getOpenKeysFromDOM());
  }

  function openDrawer() {
    var drawer = getDrawer();
    if (!drawer || isDrawerOpen()) return;
    if (typeof drawer.open === 'function') drawer.open();
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (drawer && typeof drawer.close === 'function') drawer.close();
  }

  function restoreFilterState() {
    var state = readFilterState();
    if (!state || !state.keepOpen || !state.openKeys) return;

    isRestoring = true;
    openDrawer();

    var drawer = getDrawer();
    if (drawer) {
      drawer.querySelectorAll('details').forEach(function (details) {
        if (state.openKeys.indexOf(detailsKey(details)) !== -1) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
      });
    }

    if (typeof state.scrollY === 'number') window.scrollTo(0, state.scrollY);

    window.setTimeout(function () {
      isRestoring = false;
    }, 80);
  }

  // Al abrir: "Ordenar por" y "Precio" desplegados, el resto plegado.
  function collapseDrawerToDefault() {
    var drawer = getDrawer();
    if (!drawer || isRestoring) return;

    drawer.querySelectorAll('details').forEach(function (details) {
      if (details.classList.contains('kayuri-drawer-sort') || isPriceFilter(details)) {
        details.setAttribute('open', '');
      } else {
        details.removeAttribute('open');
      }
    });

    syncFilterStateFromDOM();
  }

  function getButtonOrLink(event) {
    return event.target.closest('button, input[type="submit"], a');
  }

  function isCloseButton(event) {
    return !!event.target.closest('.theme-drawer__close-button');
  }

  function isSeeResultsElement(element) {
    if (!element) return false;
    // "+ Mostrar más" está dentro del formulario pero no debe aplicar filtros.
    if (element.closest('.show-more')) return false;
    return element.matches('.facets__see-results, [type="submit"]');
  }

  function isSeeResultsButton(event) {
    return isSeeResultsElement(getButtonOrLink(event));
  }

  function getDeferredFilterControl(target) {
    if (!isInsideDrawer(target)) return null;

    var control = target.closest('input, select, textarea');
    if (!control) {
      var label = target.closest('label');
      control = label && label.querySelector('input, select, textarea');
    }

    if (!control || control.closest('.kayuri-drawer-sort')) return null;
    return control.name && control.name.indexOf('filter.') !== -1 ? control : null;
  }

  function stopDeferredFilterAutoApply(event, shouldRefreshPreview) {
    if (!getDeferredFilterControl(event.target)) return false;

    event.stopImmediatePropagation();

    if (shouldRefreshPreview) {
      syncFilterStateFromDOM();
      updateBrowserUrlFromDrawer();
      schedulePreviewCountRefresh();
    }

    return true;
  }

  function getPendingSort() {
    try {
      return sessionStorage.getItem(PENDING_SORT_KEY);
    } catch (error) {
      return null;
    }
  }

  function setPendingSort(value) {
    try {
      sessionStorage.setItem(PENDING_SORT_KEY, value);
    } catch (error) {}
  }

  function clearPendingSort() {
    try {
      sessionStorage.removeItem(PENDING_SORT_KEY);
    } catch (error) {}
  }

  function shouldKeepActionParam(key) {
    return key !== 'page' && key !== 'section_id' && key !== 'sort_by' && key.indexOf('filter.') !== 0;
  }

  function buildDrawerFormUrl(options) {
    var form = getDrawerForm();
    if (!form) return null;

    var settings = options || {};
    var actionUrl = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
    var url = new URL(actionUrl.pathname, actionUrl.origin);
    var formData = new FormData(form);
    var pendingSort = getPendingSort();
    var current = new URL(window.location.href);

    actionUrl.searchParams.forEach(function (value, key) {
      if (shouldKeepActionParam(key)) url.searchParams.append(key, value);
    });

    // Búsqueda: conservar la consulta (q) de la URL actual.
    if (current.searchParams.get('q') && !url.searchParams.get('q')) {
      url.searchParams.set('q', current.searchParams.get('q'));
    }

    formData.forEach(function (value, key) {
      if (!key || value === '' || key === 'page' || key === 'section_id' || key === 'sort_by') return;
      url.searchParams.append(key, value);
    });

    if (pendingSort) {
      url.searchParams.set('sort_by', pendingSort);
    } else if (formData.get('sort_by')) {
      url.searchParams.set('sort_by', formData.get('sort_by'));
    }

    if (settings.includeSectionId) {
      var sectionId = getSectionId();
      if (sectionId) url.searchParams.set('section_id', sectionId);
    }

    return url;
  }

  function updateBrowserUrlFromDrawer() {
    var url = buildDrawerFormUrl();
    if (!url) return;

    if (url.toString() !== window.location.href) {
      window.history.replaceState(
        Object.assign({}, window.history.state || {}, { kayuriPendingFilters: true }),
        '',
        url.toString()
      );
    }
  }

  function applyDrawerForm() {
    var url = buildDrawerFormUrl();
    if (!url) return false;

    clearPendingSort();
    clearFilterState();

    var facetsFormComponent = getFacetsFormComponent();
    if (facetsFormComponent && typeof facetsFormComponent.updateFiltersByURL === 'function') {
      facetsFormComponent.updateFiltersByURL(url.toString());
      closeDrawer();
    } else {
      window.location.href = url.toString();
    }

    return true;
  }

  function updatePreviewFromHtml(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var currentActions = document.querySelector('#filters-drawer .facets__drawer-actions');
    var previewActions = parsed.querySelector('#filters-drawer .facets__drawer-actions');

    if (currentActions && previewActions) currentActions.innerHTML = previewActions.innerHTML;

    var currentBubble = document.getElementById('filters-drawer-bubble');
    var previewBubble = parsed.getElementById('filters-drawer-bubble');
    if (currentBubble && previewBubble) {
      currentBubble.textContent = previewBubble.textContent;
      currentBubble.hidden = previewBubble.hidden;
    }
  }

  function refreshPreviewCount() {
    var url = buildDrawerFormUrl({ includeSectionId: true });
    if (!url) return;

    previewCountRequestId += 1;
    var requestId = previewCountRequestId;

    if (previewCountController) previewCountController.abort();
    previewCountController = new AbortController();

    fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      signal: previewCountController.signal,
    })
      .then(function (response) {
        if (!response.ok) throw new Error('No se pudo actualizar el contador');
        return response.text();
      })
      .then(function (html) {
        if (requestId === previewCountRequestId) updatePreviewFromHtml(html);
      })
      .catch(function () {});
  }

  function schedulePreviewCountRefresh() {
    clearTimeout(previewCountTimer);
    previewCountTimer = window.setTimeout(refreshPreviewCount, PREVIEW_COUNT_DELAY);
  }

  window.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      if (event.target.closest('.facets-toggle__button')) {
        clearFilterState();
        window.setTimeout(collapseDrawerToDefault, 80);
        window.setTimeout(collapseDrawerToDefault, 200);
        window.setTimeout(schedulePreviewCountRefresh, 220);
        return;
      }

      if (!isInsideDrawer(event.target)) return;

      if (isCloseButton(event)) {
        clearFilterState();
        return;
      }

      if (isSeeResultsButton(event)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyDrawerForm();
        return;
      }

      if (stopDeferredFilterAutoApply(event, false)) return;

      if (event.target.closest('summary') && event.target.closest('#filters-drawer details')) {
        window.setTimeout(syncFilterStateFromDOM, 0);
        window.setTimeout(syncFilterStateFromDOM, 60);
      }
    },
    true
  );

  window.addEventListener(
    'change',
    function (event) {
      if (!(event.target instanceof Element)) return;
      var sortInput = event.target.closest('#filters-drawer .kayuri-drawer-sort input[name="sort_by"]');

      if (sortInput) {
        event.stopImmediatePropagation();
        setPendingSort(sortInput.value);
        syncFilterStateFromDOM();
        updateBrowserUrlFromDrawer();
        schedulePreviewCountRefresh();
        return;
      }

      if (isInsideDrawer(event.target)) stopDeferredFilterAutoApply(event, true);
    },
    true
  );

  window.addEventListener(
    'input',
    function (event) {
      if (event.target instanceof Element && isInsideDrawer(event.target)) stopDeferredFilterAutoApply(event, true);
    },
    true
  );

  window.addEventListener(
    'submit',
    function (event) {
      if (!(event.target instanceof Element) || !event.target.closest('#filters-drawer form')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      applyDrawerForm();
    },
    true
  );

  // Se escucha en window (fase de captura) para adelantarse a los manejadores
  // declarativos del tema, que también escuchan en captura sobre document.
  window.addEventListener('popstate', restoreFilterState);
})();
